import api from './apiService';
import { applyQueryParams } from '../utils/helpers';

class Student {
  static create(student) {
    return api.post('/students', student);
  }

  static get(filters, row, page) {
    const params = [
      { prop: 'page', value: page },
      { prop: 'row', value: row },
      { prop: 'cycle', value: filters.cycle },
      { prop: 'grade_instance', value: filters.gradeInstance },
      { prop: 'name', value: filters.name }
    ];
    return api.get(applyQueryParams('/students', params));
  }

  static getStudent(id) {
    return api.get(`/students/${id}`);
  }

  static update(student, id) {
    return api.put(`/students/${id}`, student);
  }
}

export default Student;



// WEBPACK FOOTER //
// ./src/api/studentApi.js